import { CSSObject } from '@chakra-ui/react';

export const WrapperContent: CSSObject = {
  display: 'flex',
  flexDir: 'column',
  py: ['4', null, '10'],
  px: ['2', null, '10'],
  flex: [null, null, 1],
  justifyContent: [null, null, 'center'],
  minW: ['unset', null, '460px'],
  form: {
    '.chakra-form-control': {
      '.chakra-form__label': {
        color: 'gray.500',
        fontSize: 'xs',
        fontWeight: 'semibold',
      },
    },
    'a[href*="forgot-password"]': {
      color: '#89ADF1',
      fontWeight: 'medium',
      fontSize: 'xs',
    },
    '.chakra-button[data-cy*="loginSubmit"]': {
      fontSize: 'sm',
    },
    'button[aria-label*="password toggle"]': {
      top: 'px',
    },
  },
};

export const Title: CSSObject = {
  color: 'gray.500',
  fontSize: 'md',
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: 'semibold',
  mb: '4',
  mt: [null, null, '9'],
};
